import { Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

import ProductsSearchService from '../services/ProductsSearchService';
import { FilterOptionSelectedValueModel } from '../view-models/FamilyOptionModel';

export default class SearchProductsByFamily extends Vue {
    @Prop(Number)
    public categoryId: number | null = null;

    @Prop(Number)
    public familyId: number | null = null;

    @Prop(String)
    public languageId: string = "it-IT";

    public searchResponse: any | null = null;

    private searchService: ProductsSearchService | null = null;

    onFetchRequested(pageIndex: number, filters: { [name: string]: FilterOptionSelectedValueModel } | null, orderBy: any[], thisSearchId: number | null,
        pathAndQueryString: string, retrieveFamilyOptions: boolean) {
        var instance = this;

        instance.searchService?.searchProductsByFamily(instance.familyId, instance.categoryId, pageIndex, instance.languageId, filters, orderBy,
            pathAndQueryString, retrieveFamilyOptions)
            .then((res: any) => {
                res.searchId = thisSearchId;
                instance.searchResponse = res;
            });
    }

    onHistoryPushed(pathAndQueryString: string) {
        this.searchService?.pushSearchHistory(this.familyId ?? 0, pathAndQueryString, this.languageId);
    }

    created() {
        this.searchService = new ProductsSearchService();
    }
}